import React from 'react';

const WelcomeBilling = () => (
  <div>Hello from new Unified Billing</div>
);

export default WelcomeBilling;
